<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right" v-if="!loading && !processing">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3 style="text-align: center">{{ title }}</h3>

    <!-- Failed, Credit card refused, propose to put another card -->
    <div v-if="failedToChargeCreditCard">
      <p style="text-align: center; color: red; font-weight: bold">
        Nous n'avons pas été capable de prélever le montant de votre carte de crédit. Veuillez réessayer plus
        tard ou essayer
        avec une autre carte.
      </p>
    </div>

    <!-- Payment in process -->
    <div style="text-align: center" v-if="loading">
      <p style="text-align: center">
        Nous sommes en train de traiter votre paiement.
        <br/>
        Ne fermez pas cette page.
      </p>
      <div class="spinner">
        <font-awesome-icon icon="spinner" spin/>
      </div>
    </div>

    <div style="text-align: center" v-else-if="success">
      <p style="text-align: center">
        La panier a été acheté avec succès. Vous recevrez dans quelques minutes un courriel avec
        le reçu de vos achats.
      </p>
      <div class="spinner">
        <font-awesome-icon icon="spinner" spin/>
      </div>
    </div>

    <!-- Failed, needs Credit Card -->
    <div v-else-if="needsCreditCard">
      <p>
        Veuillez entrer votre numéro de carte de crédit afin de procéder au paiement.
      </p>
      <p>
        <b style="color: red">Vos données de carte de crédit ne seront pas conservées.</b>
      </p>
      <br/>

      <label>Carte de crédit</label>

      <div class="sr-input sr-card-element" id="card-element"></div>

      <b-button variant="primary" @click="createPaymentMethod">
        <template v-if="needsCreditCard && processing">
          <font-awesome-icon icon="spinner" spin/>
        </template>
        <template v-else>
          Payer
        </template>
      </b-button>

      <br/>

      <b-button variant="secondary" style="margin-top: 10px;" @click="$emit('close')" v-if="!processing">Annuler
      </b-button>

    </div>

    <br/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'panier-payer',
    props: {
      onSuccess: {
        type: Function
      },
      title: {
        type: String
      },
      autoAddPaymentMethod: {
        type: Boolean,
        default: true
      },
      name: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        processing: false,
        loading: false,
        success: false,
        failedToChargeCreditCard: false,
        needsCreditCard: true
      };
    },

    mounted() {
      this.showCreditCardInput();
    },

    computed: {
      ...mapGetters('account', {
        getUserInfos: 'getUserInfos'
      })
    },
    methods: {
      ...mapActions('account', {
        _subscribeToPlan: 'subscribeToPlan',
        attachPaymentMethod: 'attachPaymentMethod'
      }),

      async changeCreditCard() {
        this.failedToChargeCreditCard = false;
        this.needsCreditCard = true;
        setTimeout(() => {
          this.showCreditCardInput();
        }, 200);
      },

      showCreditCardInput() {
        // Retrieve the payment method intent token from backend
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        const elements = this.stripe.elements({
          locale: 'fr'
        });
        const style = {
          base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        };
        this.card = elements.create('card', {
          style: style,
          hidePostalCode: true
        });
        this.card.mount('#card-element');
      },

      /**
       *
       * @returns {Promise<void>}
       */
      async createPaymentMethod() {
        if (!this.processing) {
          this.failedToChargeCreditCard = false;
          this.processing = true;

          try {
            // Prepare details
            const data = {
              // eslint-disable-next-line camelcase
              billing_details: {
                name: this.name || this.getUserInfos.name
              }
            };

            // Initiate the payment
            const result = await this.stripe.createPaymentMethod('card', this.card, data);
            if (result.error) {
              alert(result.error.message);
            }
            else if (this.autoAddPaymentMethod) {
              try {
                // Retrieve the payment method ID. Send it to the backend to attach it to the customer.
                await this.attachPaymentMethod(result.paymentMethod);
              }
              catch (e) {
                this.failedToChargeCreditCard = true;
                return;
              }
            }

            await this.onSuccess(result.paymentMethod);
          }
          finally {
            this.processing = false;
          }
        }
      }
    }
  };
</script>

<style scoped lang="scss">
#card-element {
  max-width: 500px;
  border: 1px solid #c3c3c3;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.btn {
  width: 100%;
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
